'use client'

import { useEffect, useState } from "react";



export function MyProcess(props) {

  return (
    <div className="flex-row flex">

      <div className="flex flex-col items-end" >
        <div onMouseUp={() => props.handleChange(0)} >< MyProcessButton selected={props.selectedIndex === 0} text="个性域界面" /></div>
        <div className="h-[4px]"></div>
        <img src={`${process.env.PUBLIC_URL}/images/Checkbox_line.svg`} width={4} height={80} className="mr-[10px]"></img>
        <div className="h-[4px]"></div>
        <div onMouseUp={() => props.handleChange(1)}> < MyProcessButton selected={props.selectedIndex === 1} text="探索更多域" /></div>
        <div className="h-[4px]"></div>
        <img src={`${process.env.PUBLIC_URL}/images/Checkbox_line.svg`} width={4} height={80} className="mr-[10px]"></img>
        <div className="h-[4px]"></div>
        <div onMouseUp={() => props.handleChange(2)}>< MyProcessButton selected={props.selectedIndex === 2} text="好友互动" /></div>
      </div>
    </div>
  )
}

export function MyProcessButton(props) {
  const [isClicked, setIsClicked] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleMouseDown = () => {
    setIsClicked(true);
  };
  const handleMouseUp = () => {
    setIsClicked(false);
  };
  return (
    <div
      style={{ cursor: "pointer" }}

      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}>
      {props.selected ? <div className="flex flex-row font-normal font-medium:text-base text-xl text-white" style={{ position: 'relative' }}><text >{props.text}</text><div className="w-[22px]" /><img src={`${process.env.PUBLIC_URL}/images/Checkbox_active_${isClicked ? 'click' : isHovered ? 'hover' : 'normal'}.svg`} width={24} height={24}></img></div> : <div className="flex flex-row items-center" style={{ height: 30 }}><img src={`${process.env.PUBLIC_URL}/images/Checkbox_unactive_${isClicked ? 'click' : isHovered ? 'hover' : 'normal'}.svg`} width={24} height={24}></img></div>}
    </div>

  )
}